import React from 'react';
import ValueCard1 from './ValueCard1';
import ValueCard2 from './ValueCard2';
import ValueCard3 from './ValueCard3';

function ValueCard({nav, data}) {
  if (nav === 'composite') {
    return <ValueCard1 data={data} type={2}/>;
  } else if (nav === 'bulk') {
    return <ValueCard1 data={data}/>;
  } else if (nav === 'online') {
    return <ValueCard3 data={data}/>;
  } else {
    return <ValueCard2 data={data}/>;
  }
}

export default ValueCard;


// WEBPACK FOOTER //
// ./src/routes/Case/ValueCard/index.js